import { Injectable } from '@angular/core';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { TabObject } from '../../components/tabs/tabs.model';
import { IRoute } from '../../models/iroute.interface';
import { RouteBuilderService } from './route-builder.service';

@Injectable()
/**
 * Builds transaction routes for driver
 */
export class ProhibitionComplianceRouteBuilderService extends RouteBuilderService {

    constructor() {
        super();
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.PACE;
    }

    /**
     * Gets the route list for the transaction type provided.
     * @returns: Array of routes for transaction.
     */
    getRouteList(businessTransactionTypeId: number): any[] {
        const routeList: IRoute[] = [];

        switch (businessTransactionTypeId) {
            case 68: {
                return this.getComplianceRoutes();
            }
            default: {
            }
        }

        return routeList;
    }

    /**
     * Gets the route list for credential issuance
     * @returns: Array of routes for Credential Issuance.
     */
    private getComplianceRoutes(): TabObject[] {

        return [
            { name: 'compliance-fees-selection', title: 'Select Compliance Fees', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false, helpContentUrl: '#CONTENT/Cross_Functional/Compliance_Fees.htm%3FTocPath%3DCross_Functional|_____7' },
        ];
    }

}
